import { Box, Grid, Icon, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreButton from "../../core/inputs/CoreButton";
import { ArrowForward } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setRouteReducer } from "../../store/actions/routeActions";
import {
  api_request,
  downloadExcel,
  setCommonReducer,
} from "../../store/actions/commonAction";
import CoreIFrame from "../../core/dataDisplay/CoreIFrame";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  API_METHOD_PUT,
  approveRejectDoc,
  dischargeSummary,
  dischargeSummaryINK,
  ENTITY_STATUS,
} from "../../config/constants";
import {
  GET_DOC_ERROR,
  GET_DOC_LOADING,
  GET_DOC_SUCCESS,
  GET_VALIDATIONS_ERROR,
  GET_VALIDATIONS_LOADING,
  GET_VALIDATIONS_SUCCESS,
  UPDATE_DOC_STATUS_ERROR,
  UPDATE_DOC_STATUS_SUCCESS,
} from "../../store/types/billTypes";
import Swal from "sweetalert2";
import {
  commonPDFDocumentDownload,
  downloadInvoiceFile,
  setBillReducer,
} from "../../store/actions/billActions";
import CompareInvoiceCard from "./CompareInvoiceCard";
import { useLocation, useNavigate } from "react-router";
import { mapExpenseTypes } from "../../helper/utils";
import { theme } from "../../config/theme";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import EditablePartsTable from "./EditablePartsTable";
import EditableDocData from "./EditableDocData";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import CoreInput from "../../core/inputs/CoreInput";
import {
  GET_DOC_FIELDS_ERROR,
  GET_DOC_FIELDS_SUCCESS,
} from "../../store/types/commonTypes";

export default function CompareInvoice() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tool = location.pathname.split("/")[1];

  const uid = useSelector((state) => state.auth?.uid);
  const document = useSelector((state) => state.bill?.document);
  const docId = useSelector((state) => state.bill?.docId);
  const docType = useSelector((state) => state.bill?.docType);
  const submitBillSuccess = useSelector(
    (state) => state?.bill?.submitBillSuccess,
  );
  const submitBillError = useSelector((state) => state?.bill?.submitBillError);
  const submitBillMessage = useSelector(
    (state) => state?.bill?.submitBillMessage,
  );
  const invoiceFileUrl = useSelector((state) => state?.bill?.invoiceFileUrl);
  const category = useSelector((state) => state?.common?.expenseTypes);
  const ledgerHeads = useSelector((state) => state.common.ledgerHeads);
  const docUpdateSuccess = useSelector((state) => state.bill.docUpdateSuccess);
  const docUpdateError = useSelector((state) => state.bill.docUpdateError);
  const appSettings = useSelector((state) => state?.common?.appSettings);
  const validations = useSelector((state) => state.bill?.validations);
  const masterDocFields = useSelector(
    (state) => state?.common?.masterDocFields,
  );

  const [filters, setFilters] = useState([]);
  const [fileType, setFileType] = useState(null);
  const [pageNum, setPageNum] = useState(0);
  const [imageStyle, setImageStyle] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const [typeMap, setTypeMap] = useState(null);
  const [valMap, setValMap] = useState(null);

  useEffect(() => {
    getMasterData();
    return () => {
      setTypeMap(null);
      setValMap(null);
      dispatch(
        setBillReducer({
          masterDocFields: [],
        }),
      );
      dispatch(
        setCommonReducer({
          docUpdateSuccess: false,
          docUpdateError: false,
          document: null,
          submitBillSuccess: false,
          submitBillError: false,
          submitBillMessage: false,
        }),
      );
    };
  }, []);

  useEffect(() => {
    if (docUpdateSuccess) {
      getbillDetails();
      dispatch(setBillReducer({ docUpdateSuccess: false }));
    }
    if (docUpdateError) {
      alert("Sorry, Internal error");
      dispatch(setBillReducer({ docUpdateError: false }));
    }
  }, [docUpdateSuccess, docUpdateError]);

  useEffect(() => {
    getbillDetails();
    getValidations();
    dispatch(
      setBillReducer({ docUpdateSuccess: false, docUpdateError: false }),
    );
  }, [docId]);

  useEffect(() => {
    if (
      masterDocFields &&
      masterDocFields[0] &&
      masterDocFields[0]?.Children?.length &&
      !typeMap &&
      !valMap
    ) {
      let typeMap = {};
      let valMap = {};
      masterDocFields[0]?.Children?.forEach((field) => {
        if (field?.Children?.length) {
          let tempTypes = {};
          let tempVals = {};
          if (field?.extraInfo?.isArray) {
            field.Children.forEach((child) => {
              tempTypes[child.name] =
                child?.inputType?.length > 0 ? child?.inputType : "text";

              if (child?.extraInfo?.dataSource) {
                tempVals[child.name] = child.extraInfo.dataSource;
              }
            });

            typeMap[field.name] = tempTypes;
            valMap[field.name] = tempVals;
          } else {
            valMap[field.name] = field?.Children?.map((child) => {
              return { id: child.label, name: child.label, label: child.label };
            });
            typeMap[field.name] =
              field?.inputType?.length > 0 ? field?.inputType : "text";
          }
        } else {
          typeMap[field.name] =
            field?.inputType?.length > 0 ? field?.inputType : "text";
          if (field.extraInfo?.dataSource) {
            valMap[field.name] = field.extraInfo.dataSource;
          }
        }
      });
      console.log(
        "Type Map and Val Map for doc type ",
        docType,
        typeMap,
        valMap,
      );
      setTypeMap(typeMap);
      setValMap(valMap);
    }
  }, [masterDocFields]);

  const getMasterData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/masterData",
        {},
        {
          name: docType,
          level: 3,
          _status: "active",
        },
        null,
        GET_DOC_FIELDS_SUCCESS,
        GET_DOC_FIELDS_ERROR,
        true,
        false,
      ),
    );
  };
  const getbillDetails = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        docType === "BUSINESS CARD" || docType === "business-card"
          ? "/doc/" + docId + "/docdata"
          : "/doc/" + docId + "/details",
        {},
        {},
        GET_DOC_LOADING,
        GET_DOC_SUCCESS,
        GET_DOC_ERROR,
        true,
        true,
      ),
    );
  };

  const getValidations = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/" + docId + "/validate",
        {},
        {},
        GET_VALIDATIONS_LOADING,
        GET_VALIDATIONS_SUCCESS,
        GET_VALIDATIONS_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  useEffect(() => {
    if (document) {
      if (document._status === ENTITY_STATUS.draft) {
        dispatch(
          api_request(
            API_METHOD_POST,
            "/doc/" + docId + "/status/update",
            { status: ENTITY_STATUS.viewed },
            {},
            null,
            UPDATE_DOC_STATUS_SUCCESS,
            UPDATE_DOC_STATUS_ERROR,
            true,
            false,
          ),
        );
      }
      if (document?.url?.includes(".pdf")) {
        dispatch(downloadInvoiceFile(document.id, "pdf"));
        setFileType("pdf");
      } else {
        dispatch(downloadInvoiceFile(document.id, "image"));
        setFileType("image");
      }
    }
  }, [document]);

  useEffect(() => {
    if (category && category[0]) {
      let expenseTypes = category[0].Children;
      expenseTypes = mapExpenseTypes(expenseTypes);
      setFilters([
        { id: 1, icon: "calendar", value: "daily", label: " Daily" },
        { id: 2, icon: "calendar", value: "monthly", label: " Monthly" },
        ...expenseTypes,
      ]);
    }
  }, [category]);

  useEffect(() => {
    if (submitBillSuccess) {
      Swal.fire({
        title: "Success",
        text: submitBillMessage,
        icon: "success",
        confirmButtonColor: theme.palette.primary.main,
      });
      dispatch(
        setBillReducer({
          submitBillSuccess: false,
          submitBillError: false,
        }),
      );
      dispatch(setRouteReducer({ compareInvoice: false }));
      dispatch(setCommonReducer({ bill: null }));
      navigate("/invoices");
    }
    if (submitBillError) {
      Swal.fire({
        title: "Oops!",
        text: submitBillMessage,
        icon: "error",
        confirmButtonColor: theme.palette.error.main,
      });
      dispatch(
        setBillReducer({
          submitBillSuccess: false,
          submitBillError: false,
        }),
      );
    }
  }, [submitBillSuccess, submitBillError]);

  useEffect(() => {
    if (invoiceFileUrl) {
      var img = new Image();
      img.onload = function () {
        var height = img.height;
        var width = img.width;
        // code here to use the dimensions
        if (height > width) {
          setImageStyle({ height: "100%", maxHeight: "100%" });
        } else {
          setImageStyle({ width: "100%" });
        }
      };

      img.src = invoiceFileUrl;
    }
  }, [invoiceFileUrl]);

  const approveDocStatus = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/" + docId + "/status/update",
        remarks && remarks?.length > 0
          ? { status: ENTITY_STATUS.approved, remarks }
          : { status: ENTITY_STATUS.approved },
        {},
        null,
        UPDATE_DOC_STATUS_SUCCESS,
        UPDATE_DOC_STATUS_ERROR,
        true,
        false,
      ),
    );
  };

  const rejectDocStatus = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/" + docId + "/status/update",
        remarks && remarks?.length > 0
          ? { status: ENTITY_STATUS.rejected, remarks }
          : { status: ENTITY_STATUS.rejected },
        {},
        null,
        UPDATE_DOC_STATUS_SUCCESS,
        UPDATE_DOC_STATUS_ERROR,
        true,
        false,
      ),
    );
  };

  const changeRemarks = (e) => {
    setRemarks(e.target.value);
  };

  const DownloadInExcel = () => {
    dispatch(
      downloadExcel({
        docId,
        tool: tool,
      }),
    );
  };

  const checkError = (err) => {
    if (err.success) {
      if (typeof err.success === "number") {
        return err.success > 100;
      } else if (
        [
          "isNonEnglish",
          "isInappropriate",
          "isTempered",
          "isHandwritten",
        ].includes(err?.name)
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        [
          "isNonEnglish",
          "isInappropriate",
          "isTempered",
          "isHandwritten",
        ].includes(err?.name)
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  // console.log(fileType);
  console.log(validations, masterDocFields, typeMap, valMap);
  // console.log("invoiceFileUrl", invoiceFileUrl);

  const appRejSet = appSettings?.find((set) => set.name === approveRejectDoc);

  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <CompareInvoiceCard>
            <CoreIconButton
              onClick={() => {
                if (document?.url.includes(".pdf")) {
                  dispatch(downloadInvoiceFile(document?.id, "pdf", false));
                  setFileType("pdf");
                } else {
                  dispatch(downloadInvoiceFile(document?.id, "jpg", false));
                  setFileType("image");
                }
              }}
              style={{
                backgroundColor: "white",
                position: "absolute",
                top: 80,
                opacity: 0.8,
              }}
            >
              <Tooltip title="Download File">
                <Icon>download</Icon>
              </Tooltip>
            </CoreIconButton>
            {fileType === "image" ? (
              imageStyle && (
                <div
                  id="image-viewer"
                  style={{
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={imageStyle}
                    src={invoiceFileUrl}
                    alt="Loading ..."
                  />
                </div>
              )
            ) : fileType === "pdf" ? (
              <CoreIFrame
                src={invoiceFileUrl}
                style={{
                  height: "100%",
                  minHeight: "100%",
                  width: "100%",
                  minWidth: "100%",
                  // "-moz-transform": "scale(0.5)",
                }}
              />
            ) : null}
          </CompareInvoiceCard>
        </Grid>
        <Grid item xs={12} sm={7} style={{ height: "100%", width: "100%" }}>
          <CompareInvoiceCard>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Box>
                <CoreIconButton onClick={() => DownloadInExcel()}>
                  <Tooltip title="Export Data">
                    <Icon>download</Icon>
                  </Tooltip>
                </CoreIconButton>
                {(document?.type === dischargeSummary ||
                  document?.type === dischargeSummaryINK) && (
                  <CoreIconButton
                    onClick={() => {
                      dispatch(commonPDFDocumentDownload(docId));
                    }}
                  >
                    <Tooltip title="Save PDF">
                      <Icon>picture_as_pdf_24</Icon>
                    </Tooltip>
                  </CoreIconButton>
                )}
              </Box>
              <div>
                <CoreIconButton
                  // variant="text"
                  onClick={() => {
                    let newNum = (pageNum - 1) % 3;
                    setPageNum(newNum);
                  }}
                >
                  <Tooltip title="Previous" placement="top">
                    <Icon>arrow_back</Icon>
                  </Tooltip>
                </CoreIconButton>
                <CoreIconButton
                  // variant="text"
                  onClick={() => {
                    let newNum = (pageNum + 1) % 3;
                    setPageNum(newNum);
                  }}
                >
                  <Tooltip title="Next" placement="top">
                    <Icon>arrow_forward</Icon>
                  </Tooltip>
                </CoreIconButton>
              </div>
            </div>
            <Box
              style={{
                minHeight: pageNum > 0 ? "100%" : "82%",
                maxHeight: pageNum > 0 ? "100%" : "82%",
                overflowY: "auto",
                padding: 12,
              }}
            >
              {pageNum == 0 ? (
                <Grid container spacing={2}>
                  {document?.DocHistories &&
                    document?.DocHistories[0]?.DocData && (
                      <EditableDocData
                        docHisId={document?.DocHistories[0]?.id}
                        data={document?.DocHistories[0]?.DocData}
                        typeMap={typeMap}
                        valMap={valMap}
                      />
                    )}
                  {document && (
                    <Grid xs={12} item>
                      <CoreTypographyBody1>
                        <strong>Document ID</strong>
                      </CoreTypographyBody1>
                      <CoreTypographyBody1>{document?.id}</CoreTypographyBody1>
                    </Grid>
                  )}
                </Grid>
              ) : pageNum === 1 ? (
                <Grid container spacing={2}>
                  <EditablePartsTable
                    typeMap={typeMap}
                    valMap={valMap}
                    docHisId={
                      document?.DocHistories
                        ? document?.DocHistories[0]?.id
                        : null
                    }
                    data={
                      document?.DocHistories[0]
                        ? document?.DocHistories[0]?.DocParticulars
                        : []
                    }
                  />
                </Grid>
              ) : pageNum == 2 ? (
                <div>
                  <CoreTypographyBody1>
                    <strong>Validations</strong>
                    <CoreIconButton onClick={getValidations}>
                      <Icon>refresh</Icon>
                    </CoreIconButton>
                  </CoreTypographyBody1>
                  {validations?.length === 0 && <p>No Validations Present</p>}

                  {validations?.map(
                    (err) =>
                      err && (
                        <p style={{ display: "flex", alignItems: "center" }}>
                          <Icon
                            color={checkError(err) ? "success" : "error"}
                            style={{ marginRight: 8 }}
                          >
                            {checkError(err) ? "check_circle" : "cancel"}
                          </Icon>{" "}
                          {err.message}
                        </p>
                      ),
                  )}
                </div>
              ) : null}
            </Box>
            {appRejSet?.value?.enabled &&
              (document?._status === ENTITY_STATUS.draft ||
              document?._status === ENTITY_STATUS.viewed ? (
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingTop: 16,
                  }}
                >
                  <CoreInput label="Remarks" onChange={changeRemarks} />
                  <Box>
                    <CoreContainedButton
                      color="error"
                      onClick={rejectDocStatus}
                    >
                      Reject
                    </CoreContainedButton>
                  </Box>
                  <Box>
                    <CoreContainedButton
                      sx={{ ml: 1 }}
                      onClick={approveDocStatus}
                    >
                      Approve
                    </CoreContainedButton>
                  </Box>
                </Box>
              ) : (
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    height: "15%",
                    alignItems: "center",
                  }}
                >
                  {document?.info?.remarks && (
                    <CoreTypographyBody1>
                      {document?.info?.remarks}
                    </CoreTypographyBody1>
                  )}
                  <Box
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <CoreTypographyBody1>
                      {document?._status?.toUpperCase()}
                    </CoreTypographyBody1>
                    {document?._status === ENTITY_STATUS.approved ? (
                      <Icon color="success">check_circle</Icon>
                    ) : document?._status === ENTITY_STATUS.rejected ? (
                      <Icon color="error">cancel</Icon>
                    ) : null}
                  </Box>
                </Box>
              ))}
          </CompareInvoiceCard>
        </Grid>
      </Grid>
    </Box>
  );
}
